import { render, staticRenderFns } from "./GLTFPoint.vue?vue&type=template&id=110c0ea2"
import script from "./GLTFPoint.vue?vue&type=script&lang=ts"
export * from "./GLTFPoint.vue?vue&type=script&lang=ts"
import style0 from "./GLTFPoint.vue?vue&type=style&index=0&id=110c0ea2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VOverlay,VProgressLinear,VSheet})
